@if (type() === 'button') {
  <button class="entity-item-action-button" mat-icon-button (click)="emitActionClick()">
    <mat-icon class="entity-item-action-button__icon">{{ icon() }}</mat-icon>
  </button>
} @else {
  <a class="entity-item-action-button" mat-icon-button [href]="link()">
    <mat-icon class="entity-item-action-button__icon">{{ icon() }}</mat-icon>
  </a>
}
